<template>
    <inertia-link class="navbar-brand" href="/">
        <picture :alt="`${$appConfig.app_name} ${trans('generic.logo')}`">
            <template v-if="withIcon">
                <source :srcset="logoFile" media="(min-width: 576px)" />
                <img :src="iconFile" :style="style" />
            </template>
            <template v-else>
                <source :srcset="logoFile" />
                <img :src="logoFile" :style="style" />
            </template>
        </picture>
    </inertia-link>
</template>

<script>
export default {
    props: {
        size: {type: Number, default: 1},
        withIcon: {type: Boolean, default: true},
    },
    data: () => ({
        height: 2.9,
    }),
    computed: {
        logoFile() {
            return this.$appConfig.logo_path + this.$appConfig.logo_file
        },
        iconFile() {
            return this.$appConfig.logo_path + this.$appConfig.icon_file
        },
        style() {
            return {
                width: 'auto',
                height: this.size * this.height + 'rem',
            }
        },
    },
}
</script>
